angular.module('mychart').controller('CcdAccessLogModalCtrl',
    ['$scope', '$uibModalInstance', 'ChartRepository', 'patientId',
        function ($scope, $modalInstance, ChartRepository, patientId) {
            'use strict';

            $scope.loading = true;
            $scope.model = {
                AccessLog: ''
            };

            ChartRepository.getAccessLog(patientId)
                .then(function (data) {
                    $scope.removeHttpError();
                    $scope.model.AccessLog = data;
                })
                .catch(function (response) {
                    $scope.addHttpError(response);
                })
                .finally(function () {
                    $scope.loading = false;
                });

            function ok() {
                $modalInstance.close('ok');
            }

            function cancel() {
                $modalInstance.dismiss('cancel');
            }

            $scope.ok = ok;
            $scope.cancel = cancel;
        }]);
